import { Box, ListItem, SvgIcon, Typography } from '@mui/material';
import Icon from 'assets/icons/bolt.svg';
import ChevronRightIcon from 'assets/icons/chevron-right.svg';
import moment from 'moment';
import { object } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';
import channelShape from 'shapes/channel';
import employeeShape from 'shapes/employee';
import connector from './connector';

const FormItem = ({ form, children, authEmployee, channel, actions }) => {
  const acknowledge = form.acknowledges?.find(m => m.user === authEmployee?.user?._id);
  const confirmedAt = acknowledge && moment.unix(acknowledge.confirmedAt).format('LL');

  const preview = () => {
    actions.fillFormDrawer.open({ message: form, channel, employee: authEmployee });
  };

  return (
    <ListItem
      onClick={preview}
      sx={{
        height: '70px',
        alignItems: 'center',
        borderBottom: 'solid 1px #dde2eb',
        cursor: 'pointer',
      }}
    >
      <SvgIcon sx={{ fontSize: 24, marginRight: '10px', color: 'primary.main' }}>
        <Icon />
      </SvgIcon>
      <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
        <Typography
          component="div"
          sx={theme => ({
            fontSize: '15px',
            fontWeight: 'normal',
            fontStyle: 'normal',
            fontStretch: 'normal',
            lineHeight: '1.47',
            letterSpacing: '-0.5px',
            color: theme.palette.black,
          })}
        >
          {children}
        </Typography>
        {confirmedAt && (
          <Typography
            component="div"
            sx={{
              fontSize: '14px',
              fontWeight: 'normal',
              fontStyle: 'normal',
              fontStretch: 'normal',
              lineHeight: '1.47',
              letterSpacing: '-0.5px',
              color: 'primary.main',
            }}
          >
            {`${I18n.t('AcknowledgementMessage.Form sent on')} ${confirmedAt}`}
          </Typography>
        )}
      </Box>
      <SvgIcon sx={{ fontSize: 14 }}>
        <ChevronRightIcon />
      </SvgIcon>
    </ListItem>
  );
};

FormItem.propTypes = {
  form: object.isRequired,
  children: object.isRequired,
  actions: object.isRequired,
  authEmployee: employeeShape.isRequired,
  channel: channelShape.isRequired,
};

export default connector(FormItem);
